import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/CommentTemplateController/CreateCommentTemplateController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import SunTextEditor from "../../../Common/SunTextEditor";
import 'react-quill/dist/quill.snow.css';

function CreateCommentTemplate({ comment, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ vc_Title: '', vc_ServiceCode: '', vc_Comment: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    useEffect(() => {
        if (comment) {
            setFormData({ vc_Title: comment.vc_Title, vc_ServiceCode: comment.vc_ServiceCode, vc_Comment: comment.vc_Comment });
        } else {
            setFormData({ vc_Title: '', vc_ServiceCode: '', vc_Comment: '' });
        }
    }, [comment]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Comment: content
        });
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (comment) {
            formData.ID = comment.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => navigate('/');
        const redirectUserList = () => navigate('/AdministrationSetting?saved=true');
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess();
            onClose();
        }, () => {
            onSuccess();
            onClose();
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="commentTemplateModal" tabIndex="-1" aria-labelledby="commentTemplateModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="commentTemplateModalLabel">{comment ? "Edit Template" : "Add Template"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="vc_Title" className="col-sm-2 col-form-label">Title:</label>
                                    <div className="col-sm-10">
                                        <input type="text" className="form-control" name="vc_Title" value={formData.vc_Title} onChange={handleFieldChange} />
                                        {errors.vc_Title && <div style={{ color: 'red' }}>{errors.vc_Title}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="vc_ServiceCode" className="col-sm-2 col-form-label">Service Code:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_ServiceCode" value={formData.vc_ServiceCode} onChange={handleFieldChange} />
                                        {errors.vc_ServiceCode && <div style={{ color: 'red' }}>{errors.vc_ServiceCode}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="vc_Comment" className="col-sm-2 col-form-label">Comments:</label>
                                    <div className="col-sm-10">
                                        
                                        <SunTextEditor
                                            value={formData.vc_Comment}
                                            onChange={(content) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    vc_Comment: content,
                                                }))
                                            }
                                        />
                                        {errors.vc_Comment && <div style={{ color: 'red' }}>{errors.vc_Comment}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {comment ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateCommentTemplate;
